import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Home from "./pages/Home";
import Sobre from "./pages/Sobre";
import Servicos from "./pages/Servicos";
import MA from "./pages/MA";
import GestaoFiscal from "./pages/GestaoFiscal";
import GestaoPositiva from "./pages/GestaoPositiva";
import GestaoPassivos from "./pages/GestaoPassivos";
import CreditoOperacoes from "./pages/CreditoOperacoes";
import HolderLawyer from "./pages/HolderLawyer";
import Parceiros from "./pages/Parceiros";
import Contato from "./pages/Contato";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/sobre" element={<Sobre />} />
              <Route path="/servicos" element={<Servicos />} />
              <Route path="/ma" element={<MA />} />
              <Route path="/gestao-fiscal" element={<GestaoFiscal />} />
              <Route path="/gestao-positiva" element={<GestaoPositiva />} />
              <Route path="/gestao-passivos" element={<GestaoPassivos />} />
              <Route path="/credito-operacoes" element={<CreditoOperacoes />} />
              <Route path="/assessoria-juridica" element={<HolderLawyer />} />
              <Route path="/parceiros" element={<Parceiros />} />
              <Route path="/contato" element={<Contato />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
